import { Box } from "@mui/material";
import { StriimModal, StriimTypography } from "@striim/striim-ui";
import React, { useEffect, useRef, useState } from "react";
import { Tabs } from "../../selectTables";
import { WhatIsTable } from "app/components/appwizard/component-wizards/wizards/source/database-reader/configs/db-providers.utils";
import App from "app";
import { FormikProps } from "formik";
import { AppVentVtsDependencyFieldsChanged } from "src/generic/fd-form-builder/fd-form-builder.utils";
interface Props {
    isVisualTableSelectionFilled: boolean;
    selectedContent: Tabs | undefined;
    entityType: WhatIsTable;
    resetSelection: Function;
    formikformRef: React.MutableRefObject<FormikProps<Object>>;
    entityPropertyName: string;
    queryKey?: string;
    multiQueryKey?: string;
}

interface Data {
    fieldsChanged: Array<string>;
    prevValues: Record<string, string>;
    proceedCb: () => {};
    cancelCb: () => {};
    visualTableSelectionNotFilledCb: () => {};
}
const defaultData = {
    fieldsChanged: [],
    prevValues: {},
    proceedCb: () => {},
    cancelCb: () => {}
};

const FieldResetModal: React.FC<Props> = React.memo(
    ({
        isVisualTableSelectionFilled,
        selectedContent,
        entityType,
        resetSelection,
        formikformRef,
        entityPropertyName,
        queryKey,
        multiQueryKey
    }) => {
        const [isModalVisible, setIsModalVisible] = useState(false);
        const dataRef = useRef<Data>(defaultData);
        const funcCalled = useRef(false);

        const handleValueChange = ({
            fieldsChanged,
            prevValues,
            proceedCb,
            cancelCb,
            visualTableSelectionNotFilledCb
        }: Data) => {
            if (!isVisualTableSelectionFilled || funcCalled.current) {
                if (!isVisualTableSelectionFilled) {
                    visualTableSelectionNotFilledCb();
                }
                return;
            }
            console.log(fieldsChanged);
            if (fieldsChanged.length > 0) {
                dataRef.current = {
                    fieldsChanged,
                    prevValues,
                    proceedCb,
                    cancelCb
                };

                setIsModalVisible(true);
            }
        };
        const handleCancel = () => {
            dataRef.current.cancelCb();
            formikformRef.current.setValues(values => ({ ...values, ...dataRef.current.prevValues }), false);
            funcCalled.current = true;
            setIsModalVisible(false);
            dataRef.current = defaultData;
            Promise.resolve().then(() => {
                funcCalled.current = false;
            });
        };
        const handleConfirm = () => {
            dataRef.current = defaultData;
            resetSelection();
            //reset form Data Tables and MultiQuery
            formikformRef.current.setValues(
                values => ({
                    ...values,
                    ...(entityPropertyName && { [entityPropertyName]: "" }),
                    ...(queryKey && { [queryKey]: "" }),
                    ...(multiQueryKey && { [multiQueryKey]: "" })
                }),
                false
            );
            setIsModalVisible(false);
            dataRef.current.proceedCb();
        };

        useEffect(() => {
            App.vent.on(AppVentVtsDependencyFieldsChanged, handleValueChange);
            return () => {
                App.vent.off(AppVentVtsDependencyFieldsChanged);
            };
        }, [isVisualTableSelectionFilled]);

        if (!isVisualTableSelectionFilled) return true;

        return (
            <Box>
                <StriimModal
                    titleContent={
                        <StriimTypography variant="h2" data-test-id="vts-reset-modal-title">
                            Reset {selectedContent === Tabs.visual ? `Selected ${entityType}s` : "Queries"}
                        </StriimTypography>
                    }
                    cancelContent="Cancel"
                    variant="error"
                    confirmContent="Reset"
                    isVisible={isModalVisible}
                    onCancel={handleCancel}
                    onConfirm={handleConfirm}
                    dialogProps={{ PaperProps: { "data-test-id": "vts-reset-modal" } } as any}
                    cancelButtonProps={{ "data-test-id": "cancel-btn" } as any}
                    confirmButtonProps={{ "data-test-id": "submit-btn" } as any}
                >
                    <StriimTypography
                        variant="body4"
                        color={"greyscale.800"}
                        fontFamily={"Inter"}
                        data-test-id="vts-reset-modal-message"
                    >
                        You have{" "}
                        {selectedContent === Tabs.visual
                            ? "selected tables"
                            : selectedContent === Tabs.query
                            ? "added queries"
                            : ""}{" "}
                        in this source. Changing the properties will remove your previous selections.
                    </StriimTypography>
                </StriimModal>
            </Box>
        );
    }
);

export default FieldResetModal;
